import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import MenuHorizontal from '../../components/layout/MenuHorizontal'
import {abrirModalCargaIndex} from '../../actions/cargaIndex/cargaIndex'
import {abrirModalImportarDatos} from '../../actions/importarDatos/importarDatos'
import {abrirModalImportarVerracosExcel} from '../../actions/importarVerracosExcel/importarVerracosExcel'
import {abrirModalImportarClientesExcel} from '../../actions/importarClientesExcel/importarClientesExcel'
import {abrirModalImportarDireccionesExcel} from '../../actions/importarDireccionesExcel/importarDireccionesExcel'
import {abrirModalImportarContactosExcel} from '../../actions/importarContactosExcel/importarContactosExcel'
import {abrirModalImportarPedidosExcel} from '../../actions/importarPedidosExcel/importarPedidosExcel'
import {abrirModalImportarLineasPedidosExcel} from '../../actions/importarLineasPedidosExcel/importarLineasPedidosExcel'
import {abrirModalImportarVerracos} from '../../actions/importarVerracos/importarVerracos'
import {abrirModalImportarPedidos} from '../../actions/importarPedidos/importarPedidos'

export function  mapStateToProps (state) {  
  return {
    showModalCargaIndex: state.cargaIndex.showModalCargaIndex,
    showModalImportarDatos: state.importarDatos.showModalImportarDatos,
    showModalImportarVerracosExcel: state.importarVerracosExcel.showModalImportarVerracosExcel,
    showModalImportarClientesExcel: state.importarClientesExcel.showModalImportarClientesExcel,
    showModalImportarDireccionesExcel: state.importarDireccionesExcel.showModalImportarDireccionesExcel,
    showModalImportarContactosExcel: state.importarContactosExcel.showModalImportarContactosExcel,
    showModalImportarPedidosExcel: state.importarPedidosExcel.showModalImportarPedidosExcel,
    showModalImportarLineasPedidosExcel: state.importarLineasPedidosExcel.showModalImportarLineasPedidosExcel,
    showModalImportarVerracos: state.importarVerracos.showModalImportarVerracos,
    showModalImportarPedidos: state.importarPedidos.showModalImportarPedidos,
    auth: state.auth,
    centro: state.auth.centro
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      abrirModalCargaIndex,
      abrirModalImportarDatos,
      abrirModalImportarVerracosExcel,
      abrirModalImportarClientesExcel,
      abrirModalImportarDireccionesExcel,
      abrirModalImportarContactosExcel,
      abrirModalImportarPedidosExcel,
      abrirModalImportarLineasPedidosExcel,
      abrirModalImportarVerracos,
      abrirModalImportarPedidos
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MenuHorizontal))